import { render } from "./issueTrust.vue?vue&type=template&id=205608b4"
import script from "./issueTrust.vue?vue&type=script&lang=js"
export * from "./issueTrust.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__